import { Component, EventEmitter, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyEmptyStateModule } from '@vendasta/galaxy/empty-state';
import { getImageSrc } from '../../shared/image-src';

@Component({
  imports: [TranslateModule, GalaxyEmptyStateModule, MatButtonModule],
  selector: 'smb-invoicing-retail-payments-empty-state',
  templateUrl: './retail-payments-empty-state.component.html',
})
export class RetailPaymentsEmptyStateComponent {
  @Output() emptyStateAction: EventEmitter<boolean> = new EventEmitter();
  readonly emptyStateImageUrl: string;

  constructor() {
    this.emptyStateImageUrl = getImageSrc('images/empty-state/vendasta-payments.png');
  }

  async onAction() {
    this.emptyStateAction.emit(true);
  }
}
